import React from 'react';
import styled from 'styled-components';
import { Container, Heading, Text, Button } from '../primitives';
import { tokens } from '../../config/themeTokens';

const Wrapper = styled.section`
  padding: ${tokens.spacing.section} 0;
  text-align: center;
  background: ${tokens.colors.primary};
  color: ${tokens.colors.background};
`;

const StyledHeading = styled(Heading)`
  color: inherit;
`;

const StyledText = styled(Text)`
  color: rgba(255, 255, 255, 0.9);
`;

const CtaWrap = styled.div`
  margin-top: ${tokens.spacing.lg};
`;

const StyledButton = styled(Button)`
  background: ${tokens.colors.background};
  color: ${tokens.colors.primary};

  &:hover {
    opacity: 0.95;
  }
`;

export function CTASection({ title, subtitle, ctaLabel, ctaHref, children }) {
  return (
    <Wrapper>
      <Container>
        {title && <StyledHeading level={2}>{title}</StyledHeading>}
        {subtitle && <StyledText>{subtitle}</StyledText>}
        {ctaLabel && ctaHref && (
          <CtaWrap>
            <StyledButton as="a" href={ctaHref}>
              {ctaLabel}
            </StyledButton>
          </CtaWrap>
        )}
        {children}
      </Container>
    </Wrapper>
  );
}

export default CTASection;
